import type { SelectOption } from '@property.com.au/ui-kit';
import { isPropertyStatusOffMarket } from './isPropertyStatusOffMarket';
import { PropertyConfig } from '../reducers/propertyConfigReducer';
import { SEARCH_HAS_IMAGES_DEFAULT } from './defaults';

export const getHasImagesOnPropertyStatusChange = (
  { propertyStatus: currentPropertyStatus, hasImages }: PropertyConfig,
  newPropertyStatus: SelectOption,
): boolean => {
  if (
    isPropertyStatusOffMarket(currentPropertyStatus?.value) &&
    !isPropertyStatusOffMarket(newPropertyStatus.value)
  ) {
    // Set has images to default because property status' other than OFF_MARKET have no images option
    return SEARCH_HAS_IMAGES_DEFAULT === 'true';
  }
  return hasImages;
};
